/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";
import Table from "../table/Table.js";
import {searchAll} from "../../../backend/read/SearchAll";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import "./TagSearch.css";
import FieldValidation from "../commons/FieldValidation";

const monthMap = {
    JAN: '01',
    FEB: '02',
    MAR: '03',
    APR: '04',
    MAY: '05',
    JUN: '06',
    JUL: '07',
    AUG: '08',
    SEP: '09',
    OCT: '10',
    NOV: '11',
    DEC: '12'       
  }
class TagList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            cols : [
                {"name": "Quarter", "attributeName": "QUARTER", "filter": true, "checkboxFilter": false},
                {"name": "Tag #", "attributeName": "TAG_ID", "filter": true, "checkboxFilter": false},
                {"name": "FTN or WO", "attributeName": "FTN_WO", "filter": true,  "checkboxFilter": false},
                {"name": "MPN", "attributeName": "PART_ID", "filter": true, "checkboxFilter": false},
                {"name": "OB S/N", "attributeName": "OB_SN", "filter": true, "checkboxFilter": false},
                {"name": "IB S/N", "attributeName": "IB_SN", "filter": true, "checkboxFilter": false},
                {"name": "Brake S/N", "attributeName": "BRAKE_SN", "filter": true, "checkboxFilter": false},
                {"name": "Station Code", "attributeName": "STATION_CODE", "filter": true,  "checkboxFilter": false},
                {"name": "Expires", "attributeName": "EXPIRES_DISPLAY", "filter": true, "checkboxFilter": false},
                {"name": "Printed (UTC)", "attributeName": "LAST_UPDATED_TIMESTAMP", "filter": false},
                {"name": "User ID", "attributeName": "USER_ID", "filter": true, "checkboxFilter": false},
            ],
            button: {"name": "Reprint", "path": ""},
            defaultSort: {"TAG_ID": "desc"},
            // Parameters for Search TOEVA-329
            searchTimeQuarterValues: [],
            searchTagValue: '',
            invalidTagValue: false,
            tagValueValidationMessage: '',
            tagValueValidationType: '',
            searchOBValue: '',
            invalidObValue: false,
            obValueValidationMessage: '',
            obValueValidationType: '',
            searchIBValue: '',
            invalidIbValue: false,
            ibValueValidationMessage: '',
            ibValueValidationType: '',
            searchSNValue: '',
            invalidSnValue: false,
            snValueValidationMessage: '',
            snValidationType: '',
            error:  null,
            loading: false
        }
    }

    //Quarter Dropdown Functions
    getPreviousQuarters(numQuarters) {
        let quarters = [];
        const now = new Date();

        // Helper function to get the start date of a quarter
        function getQuarterStart(date) {
            const month = Math.floor(date.getMonth() / 3) * 3;
            return new Date(date.getFullYear(), month, 1);
        }

        let currentQuarterStart = getQuarterStart(now);

        // Generate the list of quarters
        for (let i = 0; i < numQuarters; i++) {
            // Format: "YYYY-QX" (e.g., "2024-Q2")
            const year = currentQuarterStart.getFullYear();
            const quarter = Math.floor(currentQuarterStart.getMonth() / 3) + 1;
            quarters.push(`${year}-Q${quarter}`);

            // Move to the previous quarter
            currentQuarterStart.setMonth(currentQuarterStart.getMonth() - 3);
        }
        return quarters;
    }

    onChangeTimeQuarterValue = (searchTimeQuarterValues) => {
        this.setState({
            searchTimeQuarterValues: searchTimeQuarterValues
        });
    };

    // Populate All Options in dropdown year-quarter
    timeQuarterOptions = [{
        options: this.getPreviousQuarters(12).map((q, index) => ({
            label: (q.valueOf()),
            value: (q.valueOf()),
        }))
    }];

    //TAG Number Validations
    onChangeTagValue = (event) => {
        const value = event.target.value;
        const isValidTagNumber = value.match(/[^0-9]/g);
        let newTagValue = value.replace(/[^0-9]/g, "");
        const attemptExceed = newTagValue.length > 13;
        newTagValue = newTagValue.substring(0, 13);
        this.setState({
            searchTagValue: newTagValue
        });
        if (isValidTagNumber) {
            this.setTagValidation(true, "Tag Number is not valid. Tag Number can only be digits.");
        } else if (attemptExceed) {
            this.setTagValidation(true, "Tag Number is not valid. Please enter a Tag Number that is 13 digits or less.");
        }
    };

    setTagValidation = (invalid, message, type) => {
        this.setState({
            invalidTagValue: invalid,
            tagValueValidationMessage: (message || ""),
            tagValueValidationType: (type || "error")
        });
    };

    closeTagValueError = () => {
        this.setTagValidation(false);
    };

    // OB S/N Validations
    onChangeOB = (event) => {
        const value = event.target.value;
        const isValidOB = value.match(/[^A-Za-z0-9\s/-]/gi);
        let newObValue = value.replace(/[^A-Za-z0-9\s/-]/gi, "");
        const attemptExceed = newObValue.length > 20;
        newObValue = newObValue.substring(0, 20);
        this.setState({
            searchOBValue: newObValue
        });
        if (isValidOB) {
            this.setOBValidation(true, "OB S/N is not valid. The OB S/N cannot contain special characters.");
        } else if (attemptExceed) {
            this.setOBValidation(true, "OB S/N is not valid. Please enter an OB S/N that is 20 characters or less.");
        }
    };

    setOBValidation = (invalid, message, type) => {
        this.setState({
            invalidObValue: invalid,
            obValueValidationMessage: (message || ""),
            obValueValidationType: (type || "error")
        });
    };

    closeOBValueError = () => {
        this.setOBValidation(false);
    };

    // IB S/N Validations
    onChangeIbValue = (event) => {
        const value = event.target.value;
        const hasInvalidChar = value.match(/[^A-Za-z0-9\s/-]/gi);
        let newIbValue = value.replace(/[^A-Za-z0-9\s/-]/gi, "");
        const attemptExceed = newIbValue.length > 20;
        newIbValue = newIbValue.substring(0, 20);
        this.setState({
            searchIBValue: newIbValue
        });
        if (hasInvalidChar) {
            this.setIbValidation(true, "IB S/N is not valid. The IB S/N cannot contain special characters.");
        } else if (attemptExceed) {
            this.setIbValidation(true, "IB S/N is not valid. Please enter an IB S/N that is 20 characters or less.");
        }
    };

    setIbValidation = (invalid, message, type) => {
        this.setState({
            invalidIbValue: invalid,
            ibValueValidationMessage: (message || ""),
            ibValueValidationType: (type || "error")
        });
    };

    closeIbValueError = () => {
        this.setIbValidation(false);
    };

    //Brake S/N Validations
    onChangeBrakeSN = (event) => {
        const value = event.target.value;
        const isValidBrakeSn = value.match(/[^A-Za-z0-9\s/-]/gi);
        let newBrakeSNValue = value.replace(/[^A-Za-z0-9\s/-]/gi, "");
        const attemptExceed = newBrakeSNValue.length > 20;
        newBrakeSNValue = newBrakeSNValue.substring(0, 20);
        this.setState({
            searchSNValue: newBrakeSNValue
        });
        if (isValidBrakeSn) {
            this.setBrakeSnValidation(true, "Brake S/N is not valid. The Brake S/N cannot contain special characters.");
        } else if (attemptExceed) {
            this.setBrakeSnValidation(true, "Brake S/N is not valid. Please enter an Brake S/N that is 20 characters or less.");
        }
    };

    setBrakeSnValidation = (invalid, message, type) => {
        this.setState({
            invalidSnValue: invalid,
            snValueValidationMessage: (message || ""),
            snValidationType: (type || "error")
        });
    };

    closeSnError = () => {
        this.setBrakeSnValidation(false);
    };

    //Search Button
    onSearch = () => {
        this.setState({error:null}); 
        const emptyArray = [];
        const searchParams = {};
        let selectedQuarters = this.state.searchTimeQuarterValues
        if(!selectedQuarters || selectedQuarters.length<1) {
            this.setState({error: 'Please select atleast one Quarter',data: []});
            return;
        }
        selectedQuarters = selectedQuarters.map( qtr => qtr.value);       
        const searchSNValue= this.state.searchSNValue;
        const searchIBValue = this.state.searchIBValue;
        const searchOBValue = this.state.searchOBValue;
        const searchTagValue= this.state.searchTagValue;
        let searchParamExists = false;
        searchParams['QUARTERS'] = selectedQuarters;
        if(searchTagValue) {
            searchParams['TAG_ID'] = searchTagValue;
            searchParamExists = true;
        }
        if(searchIBValue) {
            searchParams['IB_SN'] = searchIBValue;
            searchParamExists = true;
        }
        if(searchOBValue) {
            searchParams['OB_SN'] = searchOBValue;
            searchParamExists = true;
        }
        if(searchSNValue) {
            searchParams['BRAKE_SN'] = searchSNValue;
            searchParamExists = true;
        }
        if(selectedQuarters.length>1 && !searchParamExists) {
            this.setState({error: 'Please add one more search criteria if you select multiple Quarters',data: []});
            return;
        }
        this.setState({data: emptyArray});
        this.updateTagTable(searchParams);
    };

    convertExpiresDate = (dateStr,tagid) => {
        let newDateStr = dateStr;
        try {            
            if(dateStr !== undefined && dateStr !== null && dateStr.trim() !==  '' && dateStr.length > 4) {
                const day = dateStr.slice(0,2);
                const monthStr = dateStr.slice(2,5);
                const year = dateStr.slice(5);
    
                const monthNo = monthMap[monthStr.toUpperCase()]
                if (day && monthNo &&  year ) {
                    newDateStr = `${monthNo}/${day}/${year}`
                }
            }
          } catch (e) {
            console.log('error while converting expiry date format for tagid,expirydate',tagid,dateStr)
          }
        
        return newDateStr;
    }

    updateTagTable = (searchParams) => {      
        
        this.setState({
            loading: true,
            data:[],
            error:null                           
        });        
        searchAll("TAGS",searchParams).then(r => {
            let temp = [];            
            if (r.errorType && r.errorType.toLowerCase().includes('responsesizetoolarge')) {
                const errorMsg = "Response is too large. Please narrow your search criteria";
                console.log('inside error',r.errorType);
                console.log('errorResp..',errorMsg);
                this.setState({
                    error: errorMsg,
                    loading:false
                });         
            }else {
                const data = r?.body?.data;
                if(data) {
                    const items = JSON.parse(data).Items;
                    if(items.length>0) {
                        items.forEach(element => {
                            let tempElement = element;
                            tempElement.QUARTER = element.QUARTER;
                            tempElement.TAG_ID = element.TAG_ID;
                            tempElement.FTN_WO = element.FTN_WO;
                            tempElement.PART_ID = element.PART_ID;
                            tempElement.OB_SN = element.OB_SN ? element.OB_SN : "";
                            tempElement.IB_SN = element.IB_SN ? element.IB_SN : "";
                            tempElement.BRAKE_SN = element.BRAKE_SN ? element.BRAKE_SN : "";
                            tempElement.STATION_CODE = element.STATION_CODE;
                            tempElement.EXPIRES = element.EXPIRES;
                            tempElement.EXPIRES_DISPLAY = this.convertExpiresDate(element.EXPIRES,element.TAG_ID);                
                            let timestamp = new Date(0);
                            timestamp.setUTCMilliseconds(element.LAST_UPDATED_TIMESTAMP);
                            tempElement.LAST_UPDATED_TIMESTAMP = timestamp.toLocaleString('en-US', {hour12: false, timeZone: 'UTC'});
                            tempElement.USER_ID = element.USER_ID;
                            temp.push(tempElement)
                        });
                        this.setState({
                            loading: false,
                            data: temp,
                            error:null                       
                        });
                    }else {
                        this.setState({
                            loading: false,
                            data: [],
                            error:'No data found'                       
                        });
                    }
                }else {
                    this.setState({
                        loading: false,
                        data: temp,
                        error:'Failed to fetch data. Try logout and login again.'                       
                    });
                }   
            }
            
        });
    }
    componentDidMount() {
        const prePopulateQuarters = this.getPreviousQuarters(1).map((q, index) => ({
            label: (q.valueOf()),
            value: (q.valueOf()),
        }));
        let selectedQTRs = prePopulateQuarters.map( qtr => qtr.value);
        this.setState({            
            searchTimeQuarterValues: prePopulateQuarters
        });
        const searchParams = { "QUARTERS":selectedQTRs }
        this.updateTagTable(searchParams);
    };

    

    render() {
        const error = this.state.error;
        return (            
            <div>
              <div className="list-header" id="list-header-tag-search">
                  <h2>Tag Search</h2>
              </div>
              <div className="form-main">
                  <Form className="create-form tag-form" id="tag-form">
                      <Form.Group className="form-textfield">
                          <Form.Label className="wnb-label timeQuarterCls">Tag Printed<span
                            style={{ color: 'var(--southwest-red)', paddingLeft: '2px' }}>&#10045;</span></Form.Label>
                          <Select className="time-quarter-combobox" options={this.timeQuarterOptions} isMulti
                                  placeholder="Select Year-Quarter" value={this.state.searchTimeQuarterValues}
                                  onChange={this.onChangeTimeQuarterValue} />
                          <div className="header-note"><span
                            style={{ color: 'var(--southwest-red)' }}>&#10045;</span> denotes a mandatory field
                          </div>
                      </Form.Group>

                      <Form.Group className="form-textfield">
                          <Form.Label className="wnb-label tagCls">Tag #</Form.Label>
                          <div className="field-control marginCls">
                              <Form.Control
                                type="tagValue"
                                value={this.state.searchTagValue}
                                className={(this.state.invalidTagValue && 'tagClass invalid-field-' + this.state.tagValueValidationType) || 'tagClass'}
                                placeholder="Enter Tag #"
                                onChange={this.onChangeTagValue}
                              />
                              <FieldValidation show={this.state.invalidTagValue} message={this.state.tagValueValidationMessage}
                                               type={this.state.tagValueValidationType}
                                               onClose={this.closeTagValueError} />
                          </div>
                      </Form.Group>

                      <Form.Group className="form-textfield">
                          <Form.Label className="wnb-label obCls">OB S/N</Form.Label>
                          <div className="field-control marginCls">
                              <Form.Control
                                type="obValue"
                                value={this.state.searchOBValue}
                                className={(this.state.invalidObValue && 'obClass invalid-field-' + this.state.obValueValidationType) || 'obClass'}
                                placeholder="Enter OB S/N"
                                onChange={this.onChangeOB}
                              />
                              <FieldValidation show={this.state.invalidObValue} message={this.state.obValueValidationMessage}
                                               type={this.state.obValueValidationType}
                                               onClose={this.closeOBValueError} />
                          </div>
                      </Form.Group>

                      <Form.Group className="form-textfield">
                          <Form.Label className="wnb-label ibCls">IB S/N</Form.Label>
                          <div className="field-control marginCls">
                              <Form.Control
                                type="ibValue"
                                value={this.state.searchIBValue}
                                className={(this.state.invalidIbValue && 'ibClass invalid-field-' + this.state.ibValueValidationType) || 'ibClass'}
                                placeholder="Enter IB S/N"
                                onChange={this.onChangeIbValue}
                              />
                              <FieldValidation show={this.state.invalidIbValue} message={this.state.ibValueValidationMessage}
                                               type={this.state.ibValueValidationType}
                                               onClose={this.closeIbValueError} />
                          </div>
                      </Form.Group>

                      <Form.Group className="form-textfield">
                          <Form.Label className="wnb-label snCls">Brake S/N</Form.Label>
                          <div className="field-control marginCls">
                              <Form.Control
                                type="snValue"
                                value={this.state.searchSNValue}
                                className={(this.state.invalidSnValue && 'snClass invalid-field-' + this.state.snValidationType) || 'snClass'}
                                placeholder="Enter Brake S/N "
                                onChange={this.onChangeBrakeSN}
                              />
                              <FieldValidation show={this.state.invalidSnValue} type={this.state.snValidationType}
                                               message={this.state.snValueValidationMessage}
                                               onClose={this.closeSnError} />
                          </div>
                      </Form.Group>

                      <Form.Group className="action-panel" id="search-button">
                          <Button onClick={this.onSearch}>Search</Button>
                      </Form.Group>
                  </Form>                  
              </div>               
              <div className="page-divider"></div>                            
                {this.state.loading && <div className="list-header"> <h2> Loading... </h2></div>}
                {this.state.error &&  <div className="list-header"> <h2> {error}  </h2></div>}
                {this.state.data.length > 0 && (
                     <div className="list-header">
                        <h2>Manage Tags</h2>
                    </div>   
                 )}
                {this.state.data.length > 0 && (
                    <Table data={this.state.data} cols={this.state.cols} button={this.state.button}
                            defaultSort={this.state.defaultSort} />
                    )}
            </div>
        );
    }
}

export default TagList;
